export const setCompleteInfo = (formData) => {
    return {
      type: 'SET_CSR_INFO',
      payload: formData,
    };
};